const caseList = {
  state: {
    /*经典案例
  * Id 该案例唯一标识，不可重复
  * Img 图片链接 只需要修改require里面的路径（图片存放于assets/img/caseList文件夹中）
  * Title 标题
  * Content 内容
  * CreateTime 创建时间
  * */
    caseList: [
      {
        "Id": 21,
        "Img": require('../../assets/img/caseList/斜面操作台.jpg'),
        "Title": "斜面操作台",
        "Content": "斜面操作台",
        "CreateTime": "2020-03-16T16:37:02.24"
      },
      {
        "Id": 20,
        "Img": require('../../assets/img/caseList/AE箱.jpg'),
        "Title": "AE箱",
        "Content": "AE箱",
        "CreateTime": "2020-03-15T16:37:02.24"
      },
      {
        "Id": 19,
        "Img": require('../../assets/img/caseList/BES不锈钢.jpg'),
        "Title": "BES不锈钢",
        "Content": "BES不锈钢",
        "CreateTime": "2020-03-14T16:37:02.24"
      },
      {
        "Id": 18,
        "Img": require('../../assets/img/caseList/BKL接线箱.jpg'),
        "Title": "BKL接线箱",
        "Content": "BKL接线箱",
        "CreateTime": "2020-03-13T16:37:02.24"
      },
      {
        "Id": 17,
        "Img": require('../../assets/img/caseList/ES柜.jpg'),
        "Title": "ES柜",
        "Content": "ES柜",
        "Del": null,
        "CreateTime": "2020-03-12T16:37:02.24"
      },
      {
        "Id": 10,
        "Img": require('../../assets/img/caseList/GGD配电柜.jpg'),
        "Title": "GGD配电柜",
        "Content": "GGD配电柜",
        "Del": null,
        "CreateTime": "2020-03-11T16:37:02.24"
      },
    ]
  }
}

export default caseList